import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import type { ExecutionTarget } from './execution-state';

interface ExecutionAlreadyInProgressDialogProps {
  executionTarget: ExecutionTarget | null;
  onOpenChange: (open: boolean) => void;
  open: boolean;
}

/**
 * Explains a harmless cross-user execution race without presenting it as a
 * failed transaction or requiring a recovery action from the user.
 */
export function ExecutionAlreadyInProgressDialog({
  executionTarget,
  onOpenChange,
  open,
}: ExecutionAlreadyInProgressDialogProps) {
  const subject = executionTarget === 'proposal' ? 'proposal' : 'transaction';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Execution already in progress</DialogTitle>
          <DialogDescription>
            This {subject} is already being executed.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={() => onOpenChange(false)}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
